import RichText from '@rsa-digital/evo-shared-components/components/RichText';
import { graphql } from 'gatsby';
import { kebabCase } from 'lodash';
import React from 'react';
import { Heading, StyledInfoBanner } from './styles';

type InfoBannerBlockProps = {
  info_banner: {
    heading: string;
    body: string;
  };
};

const InfoBannerBlock: React.FC<InfoBannerBlockProps> = ({ info_banner }) => (
  <StyledInfoBanner data-cy="InfoBanner" id={kebabCase(info_banner.heading)}>
    <div tabIndex={0}>
      <Heading>{info_banner.heading}</Heading>
      <RichText html={info_banner.body} />
    </div>
  </StyledInfoBanner>
);

export default React.memo(InfoBannerBlock);

export const query = graphql`
  fragment InfoBannerBlock on cs__info_banner {
    heading
    body
  }
`;
